import { Reveal, Eyebrow, PrimaryCTA } from "../components/bits";
import { FaqAccordion } from "../sections/Faq";

export default function FaqPage() {
    return (
        <main data-testid="faq-page" className="pt-28 lg:pt-32">
            <section className="mx-auto max-w-7xl px-5 lg:px-8">
                <div className="max-w-2xl">
                    <Eyebrow>FAQ</Eyebrow>
                    <h1 className="mt-4 font-serif text-4xl uppercase leading-[1.08] tracking-tight text-ink sm:text-5xl">
                        Questions, answered <span className="italic text-rose">properly.</span>
                    </h1>
                    <p className="mt-5 max-w-xl text-sm leading-relaxed text-mute sm:text-base">
                        Everything cosmetic and aesthetic clinics ask us about client reactivation — your database,
                        your booking software, your tone of voice, privacy and how results are tracked.
                    </p>
                </div>
            </section>

            <section className="mx-auto mt-12 max-w-7xl px-5 pb-20 lg:px-8">
                <Reveal>
                    <div className="grid gap-10 lg:grid-cols-[1.6fr_1fr] lg:gap-16">
                        <div className="rounded-3xl border border-linen bg-ivory px-6 py-2 sm:px-9">
                            <FaqAccordion idPrefix="faq-page" />
                        </div>
                        <div className="space-y-5">
                            <div className="grain relative overflow-hidden rounded-3xl bg-ink p-8">
                                <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-gold">Still unsure?</div>
                                <p className="mt-4 font-serif text-2xl uppercase leading-tight tracking-tight text-cream">
                                    The fastest answer is a 30-minute conversation.
                                </p>
                                <p className="mt-3 text-sm leading-relaxed text-cream/60">
                                    We’ll look at your database, your rebooking rules and where the opportunities
                                    are — before you commit to anything.
                                </p>
                                <div className="mt-7">
                                    <PrimaryCTA dark testId="faq-page-book-btn">Book a Reactivation Call</PrimaryCTA>
                                </div>
                            </div>
                            <div className="rounded-3xl border border-linen bg-ivory p-8">
                                <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-gold">The short version</div>
                                <ul className="mt-4 space-y-3">
                                    {[
                                        "Segmented outreach — never your whole database",
                                        "Messaging approved around your clinic’s tone",
                                        "Works around your existing booking software",
                                        "Results tracked down to the rebooking",
                                    ].map((t) => (
                                        <li key={t} className="flex items-start gap-3 text-sm text-mute">
                                            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-rose" />
                                            {t}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </Reveal>
            </section>
        </main>
    );
}
